const alarmMonitorZh = {
  alarmMonLang: {
    告警总览: '告警总览',
    待运维处理电站: '待运维处理电站',
    个: '个',
    告警中电站: '告警中电站',
    待运维处理告警: '待运维处理告警',
    发生中告警: '发生中告警',
    告警电站: '告警电站',
    告警列表: '告警列表',
    站点名称: '站点名称',
    电站筛选: '电站筛选',
    全部电站: '全部电站',
    无需关注电站: '无需关注电站',
    待运维电站: '待运维电站',
    查询: '查询',
    重置: '重置',
    电站名称: '电站名称',
    告警总数: '告警总数',
    待运维告警: '待运维告警',
    无需关注告警: '无需关注告警',
    操作: '操作',
    告警详情: '告警详情',
    暂无数据: '暂无数据',
    电站告警详情: '电站告警详情',
    全部: '全部',
    设备类型: '设备类型',
    全选: '全选',
    告警等级: '告警等级',
    告警类型: '告警类型',
    处理建议: '处理建议',
    时间范围: '时间范围',
    开始时间: '开始时间',
    结束时间: '结束时间',
    站点系统: '站点系统',
    设备名称: '设备名称',
    等级: '等级',
    告警标题: '告警标题',
    客户告警: '客户告警',
    告警开始时间: '告警开始时间',
    详情: '详情',
    电站系统: '电站系统',
    告警结束时间: '告警结束时间',
    返回: '返回',
    设备: '设备',
    业务: '业务',
    通讯: '通讯',
    未分级: '未分级',
    一般: '一般',
    重要: '重要',
    严重: '严重',
    运维处理: '运维处理',
    故障状态: '故障状态',
    运维告警详情: '运维告警详情',
    发生中: '发生中',
    已结束: '已结束'
  }
}
export default alarmMonitorZh
